export const filter = {
  date: '',
  supplier_id: '',
  supplier_contract_id: '',
  delivery_deadline: '',
  total_cost: '',
  status_id: '',
};